import { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import { fetchMegasigListApi } from "../../apis/megasig.api";
import { openModal } from "../../store/actions/modalAction";
import { Info } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import MegasigListUi from "./MegasigListUi";
import MegasigInfoController from "./MegasigInfoController";
import { getOverallStatus } from "./megasig.constant";

const MegasigListController = () => {
  const dispatch = useDispatch();

  const title = "Megasig Results";

  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 10,
    searchable: ["boxId"],
    search: "",
    sort: "createdAt",
    sortDirection: -1,
  });

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState({});

  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    const options = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  };

  const columns = useMemo(
    () => [
      {
        id: 1,
        fieldName: "boxId",
        label: "Box Id",
        align: "left",
        sort: true,
        renderValue: (params) => params?.boxId || "-",
      },
      {
        id: 2,
        fieldName: "createdAt",
        label: "Created At",
        align: "left",
        sort: true,
        renderValue: (params) => formatDate(params?.createdAt),
      },
      {
        id: 3,
        fieldName: "overallResult",
        label: "Overall Result",
        align: "left",
        sort: false,
        renderValue: (params) => {
          const overall = getOverallStatus(params?.status);
          return (
            <Typography
              variant="h6"
              sx={{ color: overall === "PASS" ? "green" : "error", fontWeight: "bold" }}
            >
              {overall}
            </Typography>
          );
        },
      },
      {
        id: 4,
        fieldName: "",
        label: "Action",
        align: "right",
        sort: false,
        renderValue: (params) => (
          <IconButton
            size="inherit"
            onClick={() =>
              dispatch(
                openModal(
                  <MegasigInfoController id={params?._id} />,
                  "md",
                  false,
                  "megasigInfo",
                ),
              )
            }
          >
            <Info color="info" fontSize="inherit" />
          </IconButton>
        ),
      },
    ],
    [dispatch],
  );

  const fetchList = useCallback(() => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await fetchMegasigListApi({ ...filters }),
        (response) => {
          setList(response);
          setLoading(false);
        },
        () => {
          setLoading(false);
        },
      ),
    );
  }, [dispatch, filters]);

  useEffect(() => {
    fetchList();
  }, [filters, fetchList]);

  return (
    <MegasigListUi
      title={title}
      filters={filters}
      setFilters={setFilters}
      loading={loading}
      list={list}
      columns={columns}
    />
  );
};

export default MegasigListController;
